export function stringSeparate(s: string, c: string = ",") {
  let isNegative = false;
  if (s[0] === "-") {
    s = s.substr(1);
    isNegative = true;
  }

  let di = s.indexOf(".");
  let dPart = "";
  if (di > -1) {
    dPart = s.substr(di);
    s = s.substr(0, di);
  }

  let i = s.length % 3;
  if (!c || c.length > 1) c = ",";

  let res = s.slice(0, i);
  while (i < s.length) {
    res += c + s.slice(i, i + 3);
    i += 3;
  }

  if (res[0] === c) {
    res = res.slice(1, res.length);
  }

  if (isNegative) {
    res = "-" + res;
  }

  res += dPart;

  return res;
}

export function getFlagArray(n: number) {
  let res = [];
  let s = 0;
  for (let i = Math.pow(2, Math.floor(Math.log2(n))); s < n; i /= 2) {
    if (n & i) {
      s += i;
      res.push(i);
    }
  }
  return res;
}

export function getFlag(a: number[]) {
  if (!a) return 0;
  return a.reduce((f, s) => s | f, 0);
}

export const getQuerySearchParams = (params: { [x: string]: any }) => {
  return Object.keys(params)
    .filter((x) => params[x] !== undefined && params[x] !== null)
    .map((key) => `${key}=${params[key]}`)
    .join("&");
};

export const getEnumKeyValues = (type: any) => {
  let keys = Object.keys(type).filter((x) => isNaN(parseInt(x)));

  let result = keys.map((k) => ({ key: k, value: type[k] }));

  return result;
};

const englishKeys = [
  "q",
  "w",
  "e",
  "r",
  "t",
  "y",
  "u",
  "i",
  "o",
  "p",
  "[",
  "]",
  "a",
  "s",
  "d",
  "f",
  "g",
  "h",
  "j",
  "k",
  "l",
  ";",
  "'",
  "\\",
  "z",
  "x",
  "c",
  "v",
  "b",
  "n",
  "m",
  ",",
  ".",
  "/",
  "`",
];
const persianKeys = [
  "ض",
  "ص",
  "ث",
  "ق",
  "ف",
  "غ",
  "ع",
  "ه",
  "خ",
  "ح",
  "ج",
  "چ",
  "ش",
  "س",
  "ی",
  "ب",
  "ل",
  "ا",
  "ت",
  "ن",
  "م",
  "ک",
  "گ",
  "پ",
  "ظ",
  "ط",
  "ز",
  "ر",
  "ذ",
  "د",
  "ئ",
  "و",
  ".",
  "/",
  "ژ",
];

export const toPersianString = (input: string) => {
  let output = input.replaceAll("H", "آ").replaceAll("C", "ژ").replaceAll("M", "ء").toLowerCase();

  for (let i = 0; i < output.length; i++) {
    const eIndex = englishKeys.indexOf(output[i]);
    if (eIndex > -1) {
      output = output.replaceAll(output[i], persianKeys[eIndex]);
    }
  }
  return output;
};

export const _Hyphen = "-";
export const _EnDash = "–";
export const _EmDash = "—";
export const _TimesSign = "×";
